import "./main.scss";

function HowTo() {
  return (
    <div className="howTo">
      <h3>How to Play</h3>
      <ul>
        <li>Enter you're name, Press PLay</li>
        <li>Answer the Ghosts Riddles</li>
        <li>Press on the Ghost to guess</li>
        <li>Correct answers grant points</li>
        <li>You're score displays at the end!</li>
      </ul>
    </div>
  );
}

export default HowTo;
